import { BaseImageComponent } from './../../../../../../commons/base-image/base-image.component'
import { imageUrl } from '@helpers/common'
import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core'
import { AuthService, ClientTopServices, RestServices } from '@app/services'
import { ButtonShowBigImagesComponent } from '../../../top/showBigImages/button-show-big-images/button-show-big-images.component'
import { notification } from 'onsenui'
import { Subject } from 'rxjs'
import { ImageStyle } from '../../../../../../../models'

declare var roundSlider

@Component({
    selector: 'app-modal-show-big-images',
    templateUrl: './modal-show-big-images.component.html',
    styleUrls: [
        './modal-show-big-images.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
        '../../../../../../stagingcss/canvas.component.css',
    ],
})
export class ModalShowBigImagesComponent implements OnInit, OnDestroy {
    @ViewChild(ButtonShowBigImagesComponent)
    @ViewChild('modalLoading')
    modalLoading: ElementRef
    @ViewChild('modalLoadingInput') modalLoadingInput: ElementRef
    @ViewChild('canvasImg') canvasImg: ElementRef
    @ViewChild('rangeTop') rangeTop: ElementRef
    @ViewChild('editFrame') editFrame: ElementRef
    @ViewChild('editImage') editImage: ElementRef
    @ViewChild('editWrapper') editWrapper: ElementRef
    @ViewChild('tagertFrame') tagertFrame: ElementRef
    @ViewChild('sizeImage') sizeImage: ElementRef
    @ViewChild('printEleStyleBigImage', { read: false }) printEleStyle: ElementRef
    baseImageComponent: BaseImageComponent

    hiddenModalImage: any = 'hidden'
    loading: Boolean = true
    imageId: any
    matrix: any = [1, 0, 0, 1]
    baseImageUrl: any = imageUrl
    styleResponsiveBigImage: any
    typeImageDefault = 'large'
    typeImage = 'large'
    en: any = {}
    showEN: true

    printStyle_
    removePrt: HTMLImageElement
    
    urlShowBig
    isActive = false
    isEdit = false
    hasChange = false
    editedId: string
    canvasType = 'simpleEdit' //'simpleEdit'

    changeEmittedAllArrClientTo: any
    index = 0
    showCanvas = false
    videoPadding = '0px'

    showLoading = false
    loadingStatus = ''

    sectionId = 'section-smile'
    allowDSD = false
    showCutLoading = false
    imageIndex: number
    destroy$: Subject<boolean> = new Subject<boolean>()
    // new prop for SimpleEdit
    private n1
    private n2
    private n3
    private n4
    private n5
    private n6

    inputRangeZoom = 50
    ownValue = 50
    rotate = 0
    scaleX = 1
    scaleY = 1
    inputRoundSlider = 30
    countRotateLeft = 0
    countRotateRight = 0
    isEditImage = false
    valuemarsk = 0

    dataInputPage:boolean = false;
    // end new prop for SimpleEdit
    constructor(
        private restApi: RestServices,
        private authData: AuthService,
        private clientTopServices: ClientTopServices,
        private renderer: Renderer2,
        private el: ElementRef,
    ) {
    }

    ngOnInit() {
        this.clientTopServices.changeEmitted$
        .takeUntil(this.destroy$)
        .subscribe((data) => {
            this.clean()
            if (
                data != null &&
                data != undefined &&
                data['showBigImageModal']
            ) {
                this.initEditImage(data)
                // if(data.baseImage.page == "dental") this.isEdit = false
                // else this.dataInputPage = false
                // console.log(data.baseImage)
                this.isEditImage = true
                this
            } else {
                this.initViewImage()
            }
        })
        this.changLanguage()
    }

    ngOnDestroy() {
        // Now let's also unsubscribe from the subject itself:
        if(this.destroy$){
            this.destroy$.next(true)
            this.destroy$.unsubscribe()
        }
        this.clearTempData()
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (this.isEdit) {
            this.keepImageRatio()
        } else {
            if (this.tagertFrame && this.sizeImage) {
                setTimeout(() => {
                    this.resizeImageSliderShow(
                        this.tagertFrame.nativeElement,
                        this.sizeImage.nativeElement,
                    )
                }, 1000)
            }
        }
    }

    responsiveImageShow(sizeImage, widthBigImage, matrixImage) {
        matrixImage[0] = Math.abs(matrixImage[0])
        matrixImage[3] = Math.abs(matrixImage[3])
        if (
            this.rotate % 180 === 0 &&
            Math.abs(this.scaleX) === 1 &&
            Math.abs(this.scaleY) === 1
        ) {
            widthBigImage.style.width = window.innerWidth + 'px'
            widthBigImage.style.height = window.innerHeight + 'px'
        } else {
            if (window.orientation !== undefined) {
                if (window.orientation === 0 || window.orientation === 180) {
                    const tmpW = window.innerWidth
                    this.tagertFrame.nativeElement.style.width = tmpW + 'px'
                    this.tagertFrame.nativeElement.style.height =
                        tmpW / 1.5 + 'px'
                } else {
                    const tmpH = window.innerHeight
                    this.tagertFrame.nativeElement.style.width =
                        tmpH * 1.5 + 'px'
                    this.tagertFrame.nativeElement.style.height = tmpH + 'px'
                }
                this.tagertFrame.nativeElement.style.margin = 'auto'
            } else {
                if (window.innerHeight * 1.5 > window.innerWidth) {
                    this.tagertFrame.nativeElement.style.width =
                        window.innerWidth + 'px'
                    this.tagertFrame.nativeElement.style.height =
                        window.innerWidth / 1.5 + 'px'
                    this.tagertFrame.nativeElement.style.margin = 'initial'
                    this.tagertFrame.nativeElement.style.marginTop = 'auto'
                    this.tagertFrame.nativeElement.style.marginBottom = 'auto'
                    this.tagertFrame.nativeElement.style.marginRight =
                        'initial'
                    this.tagertFrame.nativeElement.style.marginLeft = 'initial'
                } else {
                    this.tagertFrame.nativeElement.style.width =
                        window.innerHeight * 1.5 + 'px'
                    this.tagertFrame.nativeElement.style.height =
                        window.innerHeight + 'px'
                    this.tagertFrame.nativeElement.style.margin = 'initial'
                    this.tagertFrame.nativeElement.style.marginRight = 'auto'
                    this.tagertFrame.nativeElement.style.marginLeft = 'auto'
                    this.tagertFrame.nativeElement.style.marginTop = 'initial'
                    this.tagertFrame.nativeElement.style.marginBottom =
                        'initial'
                }
            }
        }

        this.responsiveImage(sizeImage, widthBigImage, matrixImage)
    }

    isPortrait() {
        return window.innerHeight > window.innerWidth
    }

    isLandscape() {
        return window.orientation === 90 || window.orientation === -90
    }

    private resizeImageSliderShow(frame, image) {
        if (
            this.rotate % 180 === 0 &&
            Math.abs(this.scaleX) === 1 &&
            Math.abs(this.scaleY) === 1
        ) {
            this.tagertFrame.nativeElement.style.width =
                window.innerWidth + 'px'
            this.tagertFrame.nativeElement.style.height =
                window.innerHeight + 'px'
        } else {
            if (window.orientation !== undefined) {
                if (window.orientation === 0 || window.orientation === 180) {
                    const tmpW = window.innerWidth
                    this.tagertFrame.nativeElement.style.width = tmpW + 'px'
                    this.tagertFrame.nativeElement.style.height =
                        tmpW / 1.5 + 'px'
                } else {
                    const tmpH = window.innerHeight
                    this.tagertFrame.nativeElement.style.width =
                        tmpH * 1.5 + 'px'
                    this.tagertFrame.nativeElement.style.height = tmpH + 'px'
                }
                this.tagertFrame.nativeElement.style.margin = 'auto'
            } else {
                if (window.innerHeight * 1.5 > window.innerWidth) {
                    this.tagertFrame.nativeElement.style.width =
                        window.innerWidth + 'px'
                    this.tagertFrame.nativeElement.style.height =
                        window.innerWidth / 1.5 + 'px'
                    this.tagertFrame.nativeElement.style.margin = 'initial'
                    this.tagertFrame.nativeElement.style.marginTop = 'auto'
                    this.tagertFrame.nativeElement.style.marginBottom = 'auto'
                    this.tagertFrame.nativeElement.style.marginRight =
                        'initial'
                    this.tagertFrame.nativeElement.style.marginLeft = 'initial'
                } else {
                    this.tagertFrame.nativeElement.style.width =
                        window.innerHeight * 1.5 + 'px'
                    this.tagertFrame.nativeElement.style.height =
                        window.innerHeight + 'px'
                    this.tagertFrame.nativeElement.style.margin = 'initial'
                    this.tagertFrame.nativeElement.style.marginRight = 'auto'
                    this.tagertFrame.nativeElement.style.marginLeft = 'auto'
                    this.tagertFrame.nativeElement.style.marginTop = 'initial'
                    this.tagertFrame.nativeElement.style.marginBottom =
                        'initial'
                }
            }
        }

        this.responsiveImage(
            image,
            this.tagertFrame.nativeElement,
            this.matrix,
        )
    }

    keepImageRatio() {
        this.responsiveImage(
            this.editImage.nativeElement,
            this.editWrapper.nativeElement,
            this.matrix,
        )
    }

    private initViewImage() {
        this.isActive = false
        this.typeImage = this.typeImageDefault
        this.hiddenModalImage = 'hidden'
        this.loading = false
        this.imageId = ''
        this.matrix = [1, 0, 0, 1]
        this.isEdit = false
    }

    private initEditImage(data) {
        this.isActive = true
        this.editedId = ''
        this.hiddenModalImage = 'active'
        this.loading = true
        this.typeImage = this.typeImageDefault
        this.isEdit = data['isEdit']
        this.imageId = data['id']
        this.imageIndex = data['imageIndex']
        this.matrix = data['matrix']
        this.baseImageComponent = data['baseImage']

        if (data['style']) {
            const style: ImageStyle = data['style']
            this.rotate = Number(style.rotate ? style.rotate : 0)
            this.scaleX = Number(style.scaleX ? style.scaleX : 1)
            this.scaleY = Number(style.scaleY ? style.scaleY : 1)
            // this.caculatorCountRotate(this.rotate % 90, this.rotate);
            this.loadDataZoomImage(this.scaleX)
        }
        try {
            this.loadRotate()
            setTimeout(() => {
                new roundSlider(
                    'tooltip1',
                    this.valuemarsk,
                    (drag) => {
                        // console.log(drag);
                        this.changeRoundSlider(drag)
                    },
                    (change) => {
                        // console.log(change);
                        this.changeRoundSlider(change)
                    },
                )
            }, 500)
        } catch (error) {
        }
        this.changeStyle(
            this.n1,
            this.n2,
            this.n3,
            this.n4,
            this.n5,
            this.n6,
            this.rotate,
            this.scaleX,
            this.scaleY,
        )

        // setTimeout(() => {
            this.urlShowBig =
                this.baseImageUrl +
                this.imageId +
                '?type=' +
                this.typeImageDefault

            if (!this.isEdit) {
            } else {
            }
            this.loading = false
        // }, 500)
    }

    private loadDataZoomImage(input) {
        if (Math.abs(input) > 1) {
            //zoom in
            const value = Math.abs(input) - 1
            this.inputRangeZoom = value * 100 + 50
        } else {
            // zoom out
            const value = 1 - Math.abs(input)
            this.inputRangeZoom = 50 - value * 100
        }
        this.ownValue = Number(this.inputRangeZoom + '')
    }

    handleError() {
        switch (this.typeImage) {
            case 'large':
                this.typeImage = 'other'
                this.urlShowBig =
                    this.baseImageUrl +
                    this.imageId +
                    '?type=' +
                    this.typeImage
                break
            case 'xlarge':
                this.typeImage = 'other'
                this.urlShowBig = this.baseImageUrl + this.imageId
                break
            case 'other':
                this.typeImage = 'medium'
                this.urlShowBig =
                    this.baseImageUrl +
                    this.imageId +
                    '?type=' +
                    this.typeImage
                break
            case 'medium':
                this.typeImage = 'null'
                this.urlShowBig =
                    this.baseImageUrl +
                    this.imageId +
                    '?type=' +
                    this.typeImage
                break
            default:
                // this.typeImage = "medium";
                // this.urlShowBig =
                //     this.baseImageUrl +
                //     this.imageId +
                //     "?type=" +
                //     this.typeImage;
                break
        }
    }

    hiddenModalBigImage(forceClose = false) {
        if (forceClose || !this.isEdit) {
            this.closePage()
        } else {
            // this.closePage();
        }
        this.clean()
    }

    responsiveImage(sizeImage, widthBigImage, matrixImage) {
        const widthRatio = widthBigImage.offsetWidth / sizeImage.clientWidth
        const heightRatio = widthBigImage.offsetHeight / sizeImage.clientHeight
        const ratioMin = widthRatio < heightRatio ? widthRatio : heightRatio
        this.n1 = ratioMin * matrixImage[0] // n1
        this.n2 =
            (widthBigImage.offsetHeight / sizeImage.clientWidth) *
            matrixImage[1] // n2
        this.n3 =
            (widthBigImage.offsetHeight / sizeImage.clientWidth) *
            matrixImage[2] // n3
        this.n4 = ratioMin * matrixImage[3] // n4
        this.n5 = (widthBigImage.offsetWidth - sizeImage.clientWidth) / 2
        this.n6 = (widthBigImage.offsetHeight - sizeImage.clientHeight) / 2

        this.changeStyle(
            this.n1,
            this.n2,
            this.n3,
            this.n4,
            this.n5,
            this.n6,
            this.rotate,
            this.scaleX,
            this.scaleY,
        )
    }

    private changeStyle(n1, n2, n3, n4, n5, n6, rotate, scaleX, scaleY) {
        this.styleResponsiveBigImage = {
            transform:
                'matrix(' +
                n1 +
                ', ' +
                n2 +
                ', ' +
                n3 +
                ', ' +
                n4 +
                ',' +
                n5 +
                ',' +
                n6 +
                ')' +
                ' rotate(' +
                rotate +
                'deg)' +
                ' scaleX(' +
                scaleX +
                ') scaleY(' +
                scaleY +
                ')',
        }
        if(this.printEleStyle) {
            let r = ' rotate(' +
            rotate +
            'deg)' +
            ' scaleX(' +
            scaleX +
            ') scaleY(' +
            scaleY +
            ')';
            const style = document.createElement('style');
    
            style.type = 'text/css';
            style.appendChild(document.createTextNode("@media print { \n .targetWrapper img {\n" + 'transform: ' + r + "!important; } \n  .targetWrapper img { position: relative !important; } \n}"));
            if (this.printStyle_) {
                this.renderer.removeChild(
                    this.printEleStyle.nativeElement,
                    this.printStyle_,
                )
                this.removePrt = null
                this.printStyle_ = null
            }
            this.printStyle_ = style
            this.renderer.appendChild(this.printEleStyle.nativeElement, style)
        }
    }

    saveAndClose() {
        if (this.isEdit && this.hasChange) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-title'] + '</b>',
                cancelable: true,
                buttonLabels: [
                    this.en['alert-cancel'],
                    this.en['alert-discard'],
                    this.en['alert-save'],
                ],
                modifier: 'rowfooter',
                callback: (i) => {
                    if (i === 0) {
                    } else if (i === 1) {
                        this.closePage()
                    } else if (i === 2) {
                        const style = this.getStyle()
                        const emmitData = {
                            imageId: this.imageId,
                            imageIndex: this.imageIndex,
                            style: style,
                        }
                        console.log(emmitData)
                        this.clientTopServices.emitSimpleEdit(emmitData)
                        this.baseImageComponent.applyStyleImage(true, style)
                        this.closePage()
                    }
                },
            })
        } else {
            this.closePage()
        }
    }
    
    closePage() {
        this.hiddenModalImage = 'hidden'
        // this.imageId = undefined;
        this.clientTopServices.emitChange(null)
        this.clearTempData()
    }

    closePageDental() {
        if(this.dataInputPage){
            this.hiddenModalImage = 'hidden'
            // this.imageId = undefined;
            this.clientTopServices.emitChange(null)
            this.clearTempData()
        }
        
    }

    changLanguage() {
        return (this.en = this.authData.showLang(this.showEN))
    }

    private getStyle(): ImageStyle {
        return {
            rotate: this.rotate,
            scaleX: this.scaleX,
            scaleY: this.scaleY,
        }
    }

    private zoomImage(value) {
        this.scaleX =
            this.scaleX > 0
                ? this.scaleX + value
                : (Math.abs(this.scaleX) + value) * -1
        this.scaleY =
            this.scaleY > 0
                ? this.scaleY + value
                : (Math.abs(this.scaleY) + value) * -1
        this.changeStyle(
            this.n1,
            this.n2,
            this.n3,
            this.n4,
            this.n5,
            this.n6,
            this.rotate,
            this.scaleX,
            this.scaleY,
        )
        this.markChange()
    }

    onZoomOut(event) {
        if (this.inputRangeZoom - event > 1) {
            const value = -event / 100
            this.inputRangeZoom -= event
            this.ownValue = Number(this.inputRangeZoom + '')
            this.zoomImage(value)
        } else {
            if (this.inputRangeZoom === 0) {
                this.inputRangeZoom = 1
            }
            const value = (1 - this.inputRangeZoom) / 100
            this.inputRangeZoom = 0
            this.ownValue = Number(this.inputRangeZoom + '')
            this.zoomImage(value)
        }
    }

    onZoomIn(event) {
        if (this.inputRangeZoom + event < 100) {
            const value = event / 100
            this.inputRangeZoom += event
            this.ownValue = Number(this.inputRangeZoom + '')
            this.zoomImage(value)
        } else {
            const value = (100 - this.inputRangeZoom) / 100
            this.inputRangeZoom = 100
            this.ownValue = Number(this.inputRangeZoom + '')
            this.zoomImage(value)
        }
    }

    zoomChange() {
        const value = (this.inputRangeZoom - this.ownValue) / 100
        this.zoomImage(value)
        this.ownValue = Number(this.inputRangeZoom + '')
    }

    flipXFunction() {
        const denta =
            this.countRotateLeft < this.countRotateRight
                ? this.countRotateRight - this.countRotateLeft
                : this.countRotateLeft - this.countRotateRight
        if (denta % 2 !== 0) {
            this.scaleY *= -1
        } else {
            this.scaleX *= -1
        }
        this.changeStyle(
            this.n1,
            this.n2,
            this.n3,
            this.n4,
            this.n5,
            this.n6,
            this.rotate,
            this.scaleX,
            this.scaleY,
        )
        this.markChange()
    }

    flipYFunction() {
        const denta =
            this.countRotateLeft < this.countRotateRight
                ? this.countRotateRight - this.countRotateLeft
                : this.countRotateLeft - this.countRotateRight
        if (denta % 2 === 0) {
            this.scaleY *= -1
        } else {
            this.scaleX *= -1
        }

        this.changeStyle(
            this.n1,
            this.n2,
            this.n3,
            this.n4,
            this.n5,
            this.n6,
            this.rotate,
            this.scaleX,
            this.scaleY,
        )
        this.markChange()
    }

    rotateRightFunction(value) {
        this.rotate += value
        this.countRotateRight++
        this.changeStyle(
            this.n1,
            this.n2,
            this.n3,
            this.n4,
            this.n5,
            this.n6,
            this.rotate,
            this.scaleX,
            this.scaleY,
        )
        this.markChange()
    }

    rotateLeftFunction(value) {
        this.rotate -= value
        this.countRotateLeft++
        // this.changeRoundSlider(this.rotate);
        this.changeStyle(
            this.n1,
            this.n2,
            this.n3,
            this.n4,
            this.n5,
            this.n6,
            this.rotate,
            this.scaleX,
            this.scaleY,
        )
        this.markChange()
    }

    changeRoundSlider(value) {
        let dentalRotate = 0
        if (this.countRotateLeft > this.countRotateRight) {
            dentalRotate = this.countRotateLeft - this.countRotateRight
            this.rotate = value - 30 + dentalRotate * 90 * -1
        } else {
            dentalRotate = this.countRotateRight - this.countRotateLeft
            this.rotate = value - 30 + dentalRotate * 90
        }
        this.markChange()
        this.changeStyle(
            this.n1,
            this.n2,
            this.n3,
            this.n4,
            this.n5,
            this.n6,
            this.rotate,
            this.scaleX,
            this.scaleY,
        )
    }

    loadRotate() {
        let mod = this.rotate % 90
        this.caculatorCountRotate(mod, this.rotate)
        this.formatValue(this.rotate)
    }

    formatValue(imgRotate) {
        var rotate = imgRotate + 30
        var mod = imgRotate % 90
        if (Math.abs(imgRotate) < 30) {
            rotate = imgRotate + 30
        } else {
            if (mod === 0) {
                rotate = 30
            } else {
                if (this.countRotateLeft > this.countRotateRight) {
                    const dentalRotate =
                        this.countRotateLeft - this.countRotateRight
                    rotate = this.rotate - dentalRotate * 90 * -1 + 30
                } else {
                    const dentalRotate =
                        this.countRotateRight - this.countRotateLeft
                    rotate = this.rotate - dentalRotate * 90 * 1 + 30
                }
            }
        }
        this.valuemarsk = rotate
    }

    caculatorCountRotate(mod, imgRotate) {
        const numberRotate = (imgRotate - mod) / 90
        if (numberRotate > 0) {
            this.countRotateRight = Math.abs(numberRotate)
        } else {
            this.countRotateLeft = Math.abs(numberRotate)
        }
        if (Math.abs(mod) > 30) {
            if (mod > 0) {
                this.countRotateRight++
            } else {
                this.countRotateLeft++
            }
        }
    }

    downloadImage(link1, domDownloadImage) {
        const style = this.getStyle()
        this.baseImageComponent.download(
            style,
            this.imageId,
            link1,
            domDownloadImage,
        )
    }

    markChange(value = true) {
        this.hasChange = value
    }

    private clearTempData() {
        this.isActive = false
        if (this.isEdit) {
        }
    }

    private clean() {
        this.n1 = 1
        this.n2 = 1
        this.n3 = 1
        this.n4 = 1
        this.n5 = 1
        this.n6 = 1
        this.scaleX = 1
        this.scaleY = 1
        this.rotate = 0
        this.countRotateLeft = 0
        this.countRotateRight = 0
        this.ownValue = 50
        this.inputRangeZoom = 50
        this.inputRoundSlider = 30
        this.baseImageComponent = null
        this.hasChange = false
        this.urlShowBig = ''
        this.valuemarsk = 30
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/showBigImages/modal-show-big-images/modal-show-big-images.component.ts